<!-- Override Market Indicators (CR-20260915-001): the ORION (OPG)'s own fieldset, hosted unchanged.
     One fieldset for one enabled side; the DUO — calls and puts, every box that side's own
     (CR-20260921-002, replacing D5's shared IV/HS) — when both sides are enabled (owner ruling #1).
     `changedKeys` (owner vrequest 2026-09-15): the anchored date's changed-since-run flags,
     cut from the Setup's diff — a box whose value differs from what the last run sent paints
     yellow, the fieldset's own cue. The manual-override cues (this date / some date) are the
     fieldset's own too, at their own scopes. -->
<div class="maven-override-block" data-element="maven-override-block">

  <ets-opg-override-indicators *ngIf="!this.duo"
      [value]="this.currentOverride"
      [side]="this.singleSide"
      [changedKeys]="this.currentChangedKeys"
      [dateLabel]="this.dateLabel"
      [sourceDateLabel]="this.sourceDateLabel"
      [showArrows]="this.showArrows"
      [canPrev]="this.canPrev"
      [canNext]="this.canNext"
      [disabled]="this.inputsDisabled"
      [rangeOverridden]="this.rangeOverridden"
      (valueChange)="this.onOverrideChanged($event)"
      (prevDate)="this.onPrev()"
      (nextDate)="this.onNext()"
      (clearDate)="this.onOverrideClear()"></ets-opg-override-indicators>

  <div class="override-duo" *ngIf="this.duo" data-element="maven-override-duo">
    <ets-opg-override-indicators
        [value]="this.currentOverride"
        [side]="'calls'"
        [sideLabel]="'calls'"
        [changedKeys]="this.currentChangedKeys"
        [dateLabel]="this.dateLabel"
        [sourceDateLabel]="this.sourceDateLabel"
        [showArrows]="this.showArrows"
        [canPrev]="this.canPrev"
        [canNext]="this.canNext"
        [disabled]="this.inputsDisabled"
        [rangeOverridden]="this.rangeOverridden"
        (valueChange)="this.onOverrideChanged($event)"
        (prevDate)="this.onPrev()"
        (nextDate)="this.onNext()"
        (clearDate)="this.onOverrideClear()"></ets-opg-override-indicators>
    <ets-opg-override-indicators
        [value]="this.currentOverride"
        [side]="'puts'"
        [sideLabel]="'puts'"
        [changedKeys]="this.currentChangedKeys"
        [dateLabel]="this.dateLabel"
        [sourceDateLabel]="this.sourceDateLabel"
        [showArrows]="this.showArrows"
        [canPrev]="this.canPrev"
        [canNext]="this.canNext"
        [disabled]="this.inputsDisabled"
        [rangeOverridden]="this.rangeOverridden"
        (valueChange)="this.onOverrideChanged($event)"
        (prevDate)="this.onPrev()"
        (nextDate)="this.onNext()"
        (clearDate)="this.onOverrideClear()"></ets-opg-override-indicators>
  </div>

</div>
